import { call, put } from 'redux-saga/effects';
// import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/infoMap';
// import { modalErrorOpen } from '../actions/modalError';
import { get } from '../../utils/api';

export function* getMap({ payload }) {
  try {
    if (payload.basebtdid) {
      const response = yield call(get, `/vehicle/dislocation/train?basebtdid=${payload.basebtdid}&bolnr=${payload.invoice}`);
      yield put(actions.getMapSuccess(response));
    }
    if (payload.freightOrder) {
      const response = yield call(get, `/vehicle/dislocation/car?freightOrderNumber=${payload.freightOrder}`);
      yield put(actions.getMapSuccess(response));
    }
  } catch (error) {
    // yield put(
    //   modalErrorOpen({
    //     message: error.response.data.message,
    //     techInfo: error.response.data.techInfo,
    //     types: 'info',
    //     title: formatMessage('textError').warning
    //   })
    // );
    yield put(actions.getMapFail());
  }
}
